"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiRoute = void 0;
const currency_1 = require("@zenlink-interface/currency");
const math_1 = require("@zenlink-interface/math");
const tiny_invariant_1 = __importDefault(require("tiny-invariant"));
const StablePool_1 = require("../StablePool");
class MultiRoute {
    get midPrice() {
        const prices = [];
        let currentAmount = this.inputAmount;
        for (const [i, path] of this.routePath.entries()) {
            let price;
            if (path.stable) {
                const outputAmount = (0, StablePool_1.getStableSwapOutputAmount)(path, currentAmount);
                price = new currency_1.Price(path.input, path.output, math_1.JSBI.multiply(math_1.ONE, currentAmount.scale), math_1.JSBI.multiply(math_1.ONE, outputAmount.scale));
                currentAmount = outputAmount;
            }
            else {
                (0, tiny_invariant_1.default)(typeof path.pair !== 'undefined', 'PAIR');
                const pair = path.pair;
                price = this.tokenPath[i].equals(pair.token0)
                    ? new currency_1.Price(pair.reserve0.currency, pair.reserve1.currency, pair.reserve0.quotient, pair.reserve1.quotient)
                    : new currency_1.Price(pair.reserve1.currency, pair.reserve0.currency, pair.reserve1.quotient, pair.reserve0.quotient);
                currentAmount = this.tokenPath[i].equals(pair.token0)
                    ? currency_1.Amount.fromRawAmount(pair.token1, currentAmount.multiply(price).quotient)
                    : currency_1.Amount.fromRawAmount(pair.token0, currentAmount.multiply(price).quotient);
            }
            prices.push(price);
        }
        return prices.slice(1).reduce((accumulator, currentValue) => accumulator.multiply(currentValue), prices[0]);
    }
    constructor(chainId, paths, inputAmount, output) {
        (0, tiny_invariant_1.default)(paths.length > 0, 'POOLS');
        (0, tiny_invariant_1.default)(paths[0].input.equals(inputAmount.currency), 'INPUT');
        (0, tiny_invariant_1.default)(typeof output === 'undefined' || paths[paths.length - 1].output.equals(output), 'OUTPUT');
        const tokenPath = [inputAmount.currency];
        for (const [i, path] of paths.entries()) {
            const currentInput = tokenPath[i];
            (0, tiny_invariant_1.default)(path.input.equals(currentInput), 'TOKENPATH');
            tokenPath.push(path.output);
        }
        this.chainId = chainId;
        this.routePath = paths;
        this.tokenPath = tokenPath;
        this.input = inputAmount.currency;
        this.inputAmount = inputAmount;
        this.output = output ?? paths[paths.length - 1].output;
    }
}
exports.MultiRoute = MultiRoute;
